import { Inject, Injectable } from '@angular/core';

import { AbstractAuthService, AUTH_SERVICE_INJECTOR } from '@campaign-portal/components-library';
import { SessionProvider } from '@campaign-portal/contracts/session';

@Injectable({ providedIn: 'root' })
export class AlarisSessionAdapter extends SessionProvider {
	constructor(@Inject(AUTH_SERVICE_INJECTOR) private readonly source: AbstractAuthService) {
		super();
	}

	logOut(): void {
		this.source.logOut();
	}
}
